export function PageHeader({ eyebrow, title, description, action, testid }) {
  return (
    <header className="px-8 pt-8 pb-6 border-b border-border" data-testid={testid}>
      <div className="flex items-end justify-between gap-6 flex-wrap">
        <div>
          {eyebrow && <div className="meta-label mb-2">{eyebrow}</div>}
          <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
          {description && (
            <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{description}</p>
          )}
        </div>
        {action}
      </div>
    </header>
  );
}
